export default __webpack_public_path__ + "images/file-close.svg?925aadfacc40af1814a8ad997f83cdcf";